module.exports = __webpack_public_path__ + "static/media/frames-25.e7af0e08.jpg";